import { isServer } from '@/shared/util/ssr';
import { LocalStorageKey } from '../LocalStorageKey';

function getCompatibleLocalStorage() {
  return !isServer
    ? localStorage
    : {
        getItem: () => undefined,
        setItem: () => undefined,
        removeItem: () => undefined,
      };
}

export const loadEnvironmentVariablesInURL = () => {
  return (
    getCompatibleLocalStorage().getItem(
      LocalStorageKey.USE_ENVIRONMENT_VAR_IN_URL_MAP_BY_DOCS_ID,
    ) || '{}'
  );
};

const saveEnvironmentVariablesInURL = (value: string) => {
  try {
    getCompatibleLocalStorage().setItem(
      LocalStorageKey.USE_ENVIRONMENT_VAR_IN_URL_MAP_BY_DOCS_ID,
      value,
    );
  } catch (error) {
    console.warn('Failed to save environment variables in URL', error);
  }
};

type EnvironmentVariablesInURLCacheType = [string, string][];

export const saveEnvironmentVariablesInURLByDocsId = (
  docsId: number | string,
  environmentVariablesInURL: EnvironmentVariablesInURLCacheType | undefined,
) => {
  try {
    const localEnvironmentsMapStr = loadEnvironmentVariablesInURL();
    const emptyEnvironmentsMap = !localEnvironmentsMapStr || localEnvironmentsMapStr === '{}';
    let localEnvironmentsMap: Record<
      string | number,
      {
        environmentVariablesInURL?: EnvironmentVariablesInURLCacheType;
      }
    > = emptyEnvironmentsMap ? {} : JSON.parse(localEnvironmentsMapStr);
    if (!localEnvironmentsMap) {
      localEnvironmentsMap = {};
    }
    localEnvironmentsMap[docsId] = {
      environmentVariablesInURL,
    };
    saveEnvironmentVariablesInURL(JSON.stringify(localEnvironmentsMap));
  } catch (error) {
    console.warn('Failed to process environment variables in URL', error);
  }
};

export const loadEnvironmentVariablesInURLByDocsId = (
  docsId: number | string,
): EnvironmentVariablesInURLCacheType | undefined => {
  try {
    const localEnvironmentsMapStr = loadEnvironmentVariablesInURL();
    if (!localEnvironmentsMapStr || localEnvironmentsMapStr === '{}') {
      return undefined;
    }
    const localEnvironmentsMap = JSON.parse(localEnvironmentsMapStr);
    return localEnvironmentsMap[docsId]?.environmentVariablesInURL;
  } catch (error) {
    console.warn('Failed to load environment variables in URL', error);
    return undefined;
  }
};
